import { message } from "antd";
import axios from "axios";
const apiURL = process.env.REACT_APP_BASE_URL;

export const formatAddress = (address) => {
  let formattedAddress =
    address &&
    `${address.streetNumber ? address.streetNumber + " " : ""}
    ${
      address.unit && address.streetName
        ? address.streetName + ", " + address.unit + ", "
        : ""
    }
    ${!address.unit && address.streetName ? address.streetName + ", " : ""}
    ${address.city ? address.city + ", " : ""} ${
      address.state ? address.state + " " : ""
    }
    ${address.zipCode ? address.zipCode : ""}`;
  if (formattedAddress) {
    return formattedAddress;
  } else {
    return "";
  }
};
export function getCityFromFullAddress(fullAddress) {
  try {
    if (!fullAddress || typeof fullAddress !== "string") {
      return "";
    }
    const parts = fullAddress.split(',')?.map(part => part?.trim());
    if (parts?.length >= 2) {
      return parts[parts.length - 2];
    }
  } catch (error) {
    return '';
  }
}

export const getFullNamesFromArray = (personsArray) => {
  if (!Array.isArray(personsArray)) return "";
  return personsArray
    .filter((person) => person && typeof person === "object" && person.fullName)
    .map((person) => person.fullName.trim())
    .join(", ");
};

export const titleOrderFormatAddress = (address) => {
  let formattedAddress =
    address &&
    `${address.streetNumber ? address.streetNumber + " " : ""}` +
    `${
      address.unit && address.streetName
        ? address.streetName + ", " + address.unit + ", "
        : ""
    }` +
    `${!address.unit && address.streetName ? address.streetName + ", " : ""}` +
    `${address.city ? address.city + ", " : ""}` +
    `${address.state ? address.state + " " : ""}` +
    `${address.zipCode ? address.zipCode : ""}`;

  if (formattedAddress) {
    return formattedAddress;
  } else {
    return "";
  }
};


export const encryptStr = (str) => {
  let n = str?.length;
  let newStr = "";
  for (let i = 0; i < n; i++) {
    if (i !== 0 && i % 4 === 0) {
      newStr += str[i] + "-";
    } else {
      newStr += str[i];
    }
  }
  return newStr;
};


export const changeExtensiontoLowerCase = (fileName) => {
  if(!fileName) return;
  const dotIndex = fileName?.lastIndexOf(".");
    const nameWithLowercaseExt = dotIndex !== -1
      ? fileName?.slice(0, dotIndex) + fileName?.slice(dotIndex)?.toLowerCase()
      : fileName;
  return nameWithLowercaseExt
}

export const getCoAgentsIds = (agentData) => {
  let agentIds = [];
  if (Array.isArray(agentData) && agentData.length) {
    agentData.forEach(el => {
      agentIds.push(el._id);
    })
  }
  return agentIds;
}

export const getPreSignedUrls = async ({filenames,type, userAuthKey}) => {
  let folderOf;
  if (type === "UPLOAD_DOC") {
    folderOf = "PDF_DOC";
  } else if (type === "SAFE_T_DRIVE") {
    folderOf = "pdf_doc";
  }else if (type === "NOTES") {
    folderOf = "MEMORIES";
  }

  try {
    const payload = {
      filenames,
      ...(folderOf && { folderOf })
    };
    const response = await axios.post(
      `${apiURL}/generatePreSignedUrls`,
      payload,
      {
        headers: {
          accept: "application/json",
          authorization: `bearer ${userAuthKey}`,
        },
      }
    );
    return response?.data?.info; 
  } catch (error) {
    message.error("Failed to get pre-signed URLs. Please try again.");
    return null;
  }
};
// Function to upload a file to a pre-signed URL
export const uploadFileToS3 = async (file, uploadUrl) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const response = await axios.put(uploadUrl, arrayBuffer, {
      headers: {
        "Content-Type": file.type,
        "Content-Length": arrayBuffer.byteLength,
      },
      transformRequest: [(data) => data],
    });
    if (response?.status === 200) {
      const responseURL = new URL(response?.request?.responseURL);
      return `${responseURL?.origin}${responseURL?.pathname}`;
    } else {
      message.error(`Failed to upload file: ${file?.name}`);
      return null;
    }
  } catch (error) {
    message.error(`Error uploading file: ${file?.name}`);
    return null;
  }
};
export const makeFirstLetterCapital = (event,form, formItem) => {
  const capitalizedValue = event?.target?.value?.charAt(0)?.toUpperCase() + event?.target?.value?.slice(1);
  if(form){
    form?.setFieldsValue({[formItem] : capitalizedValue})
  }else{
    event.target.value = capitalizedValue;
  }
}
